import { ServicesActionTypes } from './action-types';
import { ReservationServiceResourceView } from 'models';

export const setServiceResource = (
  resource: ReservationServiceResourceView | null,
  serviceId: string | null,
  slotDuration: number | null
) =>
  ({
    type: ServicesActionTypes.SET_SERVICE_RESOURCE,
    payload: { resource, slotDuration, serviceId },
  } as const);
